export const ALL_SPACES = "All Spaces";
export const BY_DEVICE = "By Device";
export const VIEW_BY = [ALL_SPACES, BY_DEVICE];

export const TEMP_F = "Temp °F";
export const MEASURE_RATING = "Rating";
const MEASURE_CO2 = "CO2";
const MEASURE_PM_25 = "PM 2.5";
const MEASURE_TVOC = "Total VOC";

export const MEASURE = [
  MEASURE_RATING,
  "CO",
  MEASURE_CO2,
  "Formaldehyde",
  "Humidity",
  "Lux",
  "O3",
  "PM 1.0",
  "PM 10",
  MEASURE_PM_25,
  TEMP_F,
  MEASURE_TVOC,
];

export const MEASURE_RESET = [
  MEASURE_RATING,
  MEASURE_CO2,
  MEASURE_PM_25,
  MEASURE_TVOC,
];

export const STANDARD_RESET = "RESET";
export const STANDARD_BUILDING_IAQ = "Building IAQ";
export const STANDARD = [STANDARD_BUILDING_IAQ, STANDARD_RESET];

const IAQ_GRADIENT_COLOR_MAP = new Map([
  ["iaq_acceptable", "#FFBD40"],
  ["iaq_elevated", "#f07020"],
  ["iaq_good", "#335299"],
  ["iaq_great", "#68acf0"],
  ["iaq_inactive", "#fff"],
]);

export const gradientColorForIAQClass = (iaqClass) => {
  return IAQ_GRADIENT_COLOR_MAP.get(iaqClass);
};

export const gradientForSensorRanges = (sensorIAQs) => {
  if (sensorIAQs.length === 1) {
    return gradientColorForIAQClass(sensorIAQs[0].iaqClass);
  }

  let result = "linear-gradient(to right, ";
  let lastPercentage = 0;
  for (const iaq of sensorIAQs) {
    const { iaqClass, percentage } = iaq;
    const percentageFloat = parseFloat(percentage);
    const color = gradientColorForIAQClass(iaqClass);

    if (lastPercentage !== 0) {
      result += `,${color} ${lastPercentage + 0.5}%, `;
    }

    result += `${color} ${lastPercentage + percentageFloat}%`;

    lastPercentage = percentageFloat;
  }
  result += ")";

  return result;
};

export const barsForSensorRanges = (description, unit, sensorIAQs) => {
  const result = [];

  let lastPercentage = 0;
  let cumulativePercentage = 0;
  for (const iaq of sensorIAQs) {
    const { percentage, ranges } = iaq;
    const percentageFloat = parseFloat(percentage);

    let verbiage = `Sustained the following ${description} ranges for ${percentage}% of the time:<hr/>`;

    for (const r of ranges) {
      const { space, range } = r;
      verbiage += `<b>${space}</b>: ${range} ${unit}<br/>`;
    }

    result.push({
      left: `${lastPercentage}%`,
      width: `${Math.min(percentageFloat, 100 - cumulativePercentage)}%`,
      description: verbiage,
    });
    lastPercentage = percentageFloat;
    cumulativePercentage += percentageFloat;
  }
  return result;
};

export const barsForSensorRange = (description, unit, sensorIAQs) => {
  const result = [];

  let lastPercentage = 0;
  for (const iaq of sensorIAQs) {
    const { percentage, range } = iaq;
    const percentageFloat = parseFloat(percentage);

    result.push({
      left: `${lastPercentage}%`,
      width: `${percentageFloat}%`,
      description: `Sustained ${description} range of ${range} ${unit} for ${percentage}% of the time`,
    });
    lastPercentage = percentageFloat;
  }
  return result;
};
